import React from 'react';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  hpBaseLayer,
  layerDegHPB,
  layerDegHPC,
  layerHPA,
} from '../../../../styles/commonStyles';

const DropBoxButton = ({ buttonsHandler, title }) => {
  return (
    <IndentLayer>
      <FistLayer>
        <SecondIndentLayer>
          <TopLayer onClick={() => buttonsHandler(title)}>{title}</TopLayer>
        </SecondIndentLayer>
      </FistLayer>
    </IndentLayer>
  );
};

export default DropBoxButton;

const IndentLayer = styled.div`
  border-radius: 20px;
  height: 20px;
  width: 80px;
  ${layerHPA}

  ${flexBoxCenter}
`;

const FistLayer = styled.div`
  height: 19px;
  width: 79px;

  border-radius: 18px;
  ${layerDegHPB}

  ${flexBoxCenter}
`;

const SecondIndentLayer = styled.div`
  height: 15px;
  width: 75px;

  border-radius: 18px;
  ${layerDegHPC}
  ${flexBoxCenter}
`;

const TopLayer = styled.button`
  height: 13px;
  width: 71px;

  font-size: 10px;

  border-radius: 16px;
  ${layerDegHPB}

  ${flexBoxCenter}
`;
